import DefaultLayout from '~/components/layouts/DefaultLayout';

export function IntegrationPickerRow({
  title,
  subtitle,
  children,
  secondary = false,
}) {
  ('h-full border-t border-gray-600 bg-gray-0 border-opacity-10');
  return (
    <div
      className={classnames([
        'px-10',
        'py-6',
        secondary
          ? 'h-full border-t border-gray-600 bg-gray-0 border-opacity-10'
          : null,
      ])}
    >
      <h3 className="text-base font-medium">{title}</h3>
      <p className="mb-6 text-base text-gray-600">{subtitle}</p>
      <div className="grid gap-6 grid-cols-integration-picker">{children}</div>
    </div>
  );
}

export const IntegrationPickerLayout = ({
  title,
  subtitle,
  loading,
  tile,
  children,
}) => {
  return (
    <DefaultLayout
      background="white"
      loading={loading}
      shadow
      subtitle={subtitle}
      tile={tile}
      title={title}
    >
      <div className="flex flex-col flex-grow">{children}</div>
    </DefaultLayout>
  );
};
